/**
 * STATS_TICK_MS — частота опроса getStats и проверки freeze (мс).
 * PUBLISH_EVERY_N_TICKS — раз в сколько тиков шлём bitrate/FPS в RUM.
 * NO_FRAME_THRESHOLD_MS — после какого молчания кадров считаем это freeze'ом.
 * FREEZE_DELTA_TIMEOUT_MS — потолок длины одной измеряемой паузы.
 */
export const STATS_TICK_MS = 500;
export const PUBLISH_EVERY_N_TICKS = 10;
export const NO_FRAME_THRESHOLD_MS = 1000;
export const FREEZE_DELTA_TIMEOUT_MS = 10 * 60 * 1000;
